import React from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';
import type { MockMatchResult } from '@/types/purchaseFlow';

interface MatchTableBlockProps {
  data: unknown;
}

const MatchTableBlock: React.FC<MatchTableBlockProps> = ({ data }) => {
  const match = data as MockMatchResult;
  if (!match?.lines) return null;

  return (
    <div className="mt-2 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div className={`px-3 py-2 flex items-center gap-2 text-xs font-medium ${
        match.overall_match
          ? 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-400'
          : 'bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400'
      }`}>
        {match.overall_match
          ? <><CheckCircle className="w-3.5 h-3.5" /> Three-Way Match: All Matched</>
          : <><AlertTriangle className="w-3.5 h-3.5" /> Three-Way Match: Discrepancies Found</>
        }
      </div>

      <table className="w-full text-xs">
        <thead>
          <tr className="bg-gray-50 dark:bg-gray-800 text-gray-500 dark:text-gray-400">
            <th className="text-left px-3 py-1.5 font-medium">Item</th>
            <th className="text-right px-2 py-1.5 font-medium">PO</th>
            <th className="text-right px-2 py-1.5 font-medium">Recv</th>
            <th className="text-right px-2 py-1.5 font-medium">Inv</th>
            <th className="text-center px-2 py-1.5 font-medium w-8"></th>
          </tr>
        </thead>
        <tbody>
          {match.lines.map((line, i) => (
            <tr key={i} className={`border-t border-gray-100 dark:border-gray-700 ${
              !line.match ? 'bg-amber-50/50 dark:bg-amber-900/10' : ''
            }`}>
              <td className="px-3 py-1.5 text-gray-700 dark:text-gray-300 truncate max-w-[120px]">
                {line.product_name}
              </td>
              <td className="px-2 py-1.5 text-right font-mono text-gray-600 dark:text-gray-400">{line.po_qty}</td>
              <td className="px-2 py-1.5 text-right font-mono text-gray-600 dark:text-gray-400">{line.received_qty}</td>
              <td className="px-2 py-1.5 text-right font-mono text-gray-600 dark:text-gray-400">{line.invoiced_qty}</td>
              <td className="px-2 py-1.5 text-center">
                {line.match
                  ? <CheckCircle className="w-3.5 h-3.5 text-emerald-500 inline" />
                  : <AlertTriangle className="w-3.5 h-3.5 text-amber-500 inline" />
                }
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 font-medium text-gray-700 dark:text-gray-300">
            <td className="px-3 py-1.5">Total</td>
            <td className="px-2 py-1.5 text-right font-mono">{match.po_total.toLocaleString()}</td>
            <td className="px-2 py-1.5 text-right font-mono">{match.inbound_total.toLocaleString()}</td>
            <td className="px-2 py-1.5 text-right font-mono">{match.invoice_total.toLocaleString()}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default MatchTableBlock;
